























import { isAfter } from 'date-fns';
import Vue, { PropType } from 'vue';
import { CandidateStudyProgram } from '~/services/CSPService';

interface StudyProgramDetail {
    id: string;
    school: string;
    name: string;
    level: string;
    timeSpan: string;
    logo: string;
}

export default Vue.extend({
    name: 'StudyProgramDetails',
    props: {
        program: {
            type: Object as PropType<CandidateStudyProgram>,
            required: true,
        },

        noLine: Boolean,
        withEdit: Boolean,
    },
    computed: {
        details(): StudyProgramDetail {
            const p = this.program;

            const level = p.studyProgram.level ? p.studyProgram.level.name : '';
            const end = isAfter(p.end, new Date())
                ? this.$t('general.present')
                      .toString()
                      .toLocaleLowerCase()
                : p.end.getFullYear();
            const timeSpan = `${p.start.getFullYear()} - ${end}`;

            const school = p.studyProgram.school
                ? p.studyProgram.school.name
                : p.studyProgram.customSchoolName || '';
            const logo = p.studyProgram.school ? p.studyProgram.school.logo : '';

            return {
                id: p.id,
                school,
                name: p.studyProgram.name,
                level,
                timeSpan,
                logo,
            };
        },
    },
});
